import { render } from "./FilterTags.vue?vue&type=template&id=18fa63ca"
import script from "./FilterTags.vue?vue&type=script&lang=js"
export * from "./FilterTags.vue?vue&type=script&lang=js"

import "./FilterTags.vue?vue&type=style&index=0&id=18fa63ca&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__